import { MaterialType, MaterialTypeKey } from '@/enums/MaterialType';

export default {
  methods: {
    mountMaterial(material) {
      switch (material) {
        case MaterialType.PAPER:
          return MaterialTypeKey.PAPER;
        case MaterialType.PLASTIC:
          return MaterialTypeKey.PLASTIC;
        case MaterialType.GLASS:
          return MaterialTypeKey.GLASS;
        default:
          return MaterialTypeKey.METAL;
      }
    },

    toggleSelected(id) {
      if (this.nfeIds.includes(id)) {
        this.nfeIds = this.nfeIds.filter((nfeId) => nfeId !== id);
      } else {
        this.nfeIds.push(id);
      }
    },

    calculateCreditsSum() {
      this.creditsSum = this.offersPayload.reduce((acc, curr) => acc + parseFloat(curr.quantity), 0).toFixed(2);
    },

    formatNewOffer(nfes, unitValue) {
      const formattedUnitValue = Number(unitValue.replace(',', '.'));
      const sumCredit = nfes.reduce((acc, curr) => acc + parseFloat(curr.quantity), 0).toFixed(2);

      this.creditsSum = (parseFloat(this.creditsSum) + parseFloat(sumCredit)).toFixed(2);

      return {
        unit_value: formattedUnitValue,
        nfe_ids: nfes.map((nfe) => nfe.id),
        quantity: parseFloat(sumCredit),
        status: 'active',
      };
    },

    updateNfesAvailable() {
      this.nfeIds.forEach((nfeId) => {
        const index = this.nfesAvailable.findIndex((nfe) => nfe.id === nfeId);
        this.nfesAvailable.splice(index, 1);
      });
    },

    resetForm() {
      this.unitValue = null;
      this.nfeIds = [];
    },
  },
};
